export default __webpack_public_path__ + "static/media/OrganicChemistry.5d7b018f.png";